import AppDispatcher from '../dispatcher/AppDispatcher';
import MoveMoneyConstants from '../constants/MoveMoneyConstants';
import StringConstants from '../constants/StringConstants';
import { parsePaymentHistoryResponse } from '../parsers/PaymentHistoryParser';
import { getPaymentStatusList } from '../utils/PaymentsStatusApiUtils';

export const SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY =
  'SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY';
export const CLEAR_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY =
  'CLEAR_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY';

const raise = (actionType, data) => {
  AppDispatcher.handleViewAction({
    actionType,
    data,
  });
};

export const saveNavigationReference = (taskUrl) => {
  raise(MoveMoneyConstants.SET_PAYMENT_STATUS_BACK_URL, taskUrl);
};
export const getPaymentHistory = (paymentHistoryRequest) => {
  raise(MoveMoneyConstants.GET_PAYMENT_HISTORY_LIST, paymentHistoryRequest);
};
export const fetchMorePaymentHistory = (paymentHistoryRequest) => {
  raise(MoveMoneyConstants.FETCH_MORE_PAYMENT_HISTORY, paymentHistoryRequest);
};
export const getPaymentStatusData = () => {
  getPaymentStatusList();
};

export const setSelectedAccountIdForPaymentHistory = (selectedAccountId) => {
  raise(SET_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY, selectedAccountId);
};

export const clearSelectedAccountIdForPaymentHistory = () => {
  raise(CLEAR_SELECTED_ACCOUNT_FOR_PAYMENT_HISTORY);
};

export const handleSuccessReponsePaymentHistoryList = (response) => {
  const paymentHistoryList = parsePaymentHistoryResponse(response);
  const showMore =
    paymentHistoryList.length < StringConstants.TRANSACTION_LIMIT
      ? false
      : true;
  raise(MoveMoneyConstants.SET_PAYMENT_HISTORY_LIST, {
    paymentHistoryList,
    showMore,
  });
};
export const handleSuccessReponsePaymentStatusList = (response) => {
  raise(MoveMoneyConstants.SET_PAYMENT_STATUS_LIST, response);
};
export const handleErrorReponsePaymentHistoryList = (error, status) => {
  raise(MoveMoneyConstants.SET_PAYMENT_HISTORY_ERROR, { error, status });
};
